import { create, useModal } from "@ebay/nice-modal-react";
import { canv } from "@/canv/global";
import { AiAgentStarsIcon } from "@/icons";
import { Button } from "@/shared/ui/Button";
import { HStack, VStack } from "@/shared/ui/Stack";
import { Modal } from "../../Modal/Modal";
import styles from "./AiAgentFreeModal.module.css";

const AiAgentFreeModal = create(function AiAgentFreeModal() {
    const { resolve, hide, remove } = useModal();

    const handleClose = () => {
        resolve();
        hide();
        remove();
    };

    const handleUpgradeButtonClick = () => {
        const teamId = canv.getInitDataProp("teamId");
        if (!teamId) return;

        window.open(`${canv.host}/dashboard?need_tariff_payment=true&teamId=${teamId}`, "_blank");
    };

    return (
        <Modal onClose={handleClose}>
            <VStack gap={24}>
                <VStack gap={16} fullWidth>
                    <AiAgentStarsIcon />

                    <h2 className={styles.title}>Ваш помощник в тарифе Pro</h2>

                    <p className={styles.text}>
                        С ИИ-помощником можно изменять, сокращать и резюмировать тексты, подводить
                        итоги ретро и исправлять ошибки — пока только в тарифе Pro
                    </p>
                </VStack>

                <HStack gap={16} fullWidth>
                    <Button fullWidth onClick={handleUpgradeButtonClick}>
                        Повысить тариф
                    </Button>
                    <Button variant="tertriary" fullWidth onClick={handleClose}>
                        Не сейчас
                    </Button>
                </HStack>
            </VStack>
        </Modal>
    );
});

export { AiAgentFreeModal };
